import React from 'react';
import Link from 'gatsby-link';
import './_navigation.scss';

import Logo from '../../resources/icons/logo.svg';
import SwitchButton from './switchbutton';
import Burger from '../../resources/icons/menu-icon.svg';
import Close from '../../resources/icons/icon-close.svg';

export default class Navigation extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            navigation: false,
        }
    }

    toggleNavigation = () => (
        this.setState({
            navigation: !this.state.navigation,
        })
    )

    render() {
        let { navigation } = this.state;
        return  (
            <div className="container-navigation">
                <nav className="desktop">
                    <Link to="/" className="brand no-border"><img src={Logo} className="nav-brandicon" /></Link>
                    <div className="nav-links">
                        <Link className="nav-link light" to="/leistungen" activeClassName="current-page">Leistungen</Link>
                        <Link className="nav-link light" to="/geraete" activeClassName="current-page">Geräte</Link>
                        <Link className="nav-link light" to="/bkfp" activeClassName="current-page">BKFP</Link>
                        <Link className="nav-link light" to="/about" activeClassName="current-page">Über&nbsp;uns</Link>
                        <Link className="nav-link light" to="/contact" activeClassName="current-page">Kontakt</Link>
                        <Link className="nav-link light" to="/faq" activeClassName="current-page">FAQ</Link>
                    </div>
                    <SwitchButton/>
                </nav>
                <nav className={'mobile' + (navigation?' active':'')}>
                    <Link to="/" className="brand no-border"><img src={Logo} className="nav-brandicon" /></Link>
                    <div className={"nav-links"  + (navigation?' active':'')}>
                        <img src={Close} className="nav-close" onClick={()=>this.toggleNavigation()} />
                        <Link className="nav-link light" to="/leistungen" activeClassName="current-page" onClick={()=>this.toggleNavigation()}>Leistungen</Link>
                        <Link className="nav-link light" to="/geraete" activeClassName="current-page" onClick={()=>this.toggleNavigation()}>Geräte</Link>
                        <Link className="nav-link light" to="/bkfp" activeClassName="current-page" onClick={()=>this.toggleNavigation()}>BKFP</Link>
                        <Link className="nav-link light" to="/about" activeClassName="current-page" onClick={()=>this.toggleNavigation()}>Über&nbsp;uns</Link>
                        <Link className="nav-link light" to="/contact" activeClassName="current-page" onClick={()=>this.toggleNavigation()}>Kontakt</Link>
                        <hr/>
                        <span className="nav-link dark">Ihre Bilder</span>
                        <a href="https://www.xrweb.mr-vorarlberg.at/Login/IndexTan" className="nav-link light">Für Patienten</a>
                        <a href="https://www.xrweb.mr-vorarlberg.at" className="nav-link light">Für Zuweiser</a>
                    </div>
                    <div className="nav-trigger" onClick={()=>this.toggleNavigation()} >
                        <img src={Burger} />
                    </div>
                </nav>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/navigation/index.jsx